var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.166 8.16406H4.83398C2.174 8.16406 0 10.3285 0 12.998V42.002C0 44.6725 2.1754 46.8359 4.83398 46.8359H50.166C52.826 46.8359 55 44.6715 55 42.002V12.998C55 10.3279 52.8249 8.16406 50.166 8.16406ZM49.4237 11.3867C47.8608 12.9548 29.5029 31.3726 28.7487 32.1292C28.1187 32.7611 26.8816 32.7615 26.2513 32.1292L5.57627 11.3867H49.4237ZM3.22266 41.4095V13.5905L17.0871 27.5L3.22266 41.4095ZM5.57627 43.6133L19.3621 29.7825L23.9689 34.4043C25.8568 36.2983 29.144 36.2975 31.0312 34.4043L35.638 29.7826L49.4237 43.6133H5.57627ZM51.7773 41.4095L37.9129 27.5L51.7773 13.5905V41.4095Z",
    fill: "black"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e80b3a3a62900479e9f5b5f06688d79d.svg";
export { ForwardRef as ReactComponent };